module.exports = __webpack_public_path__ + "static/tyrant04-sq-807f85b4633b92778d5a6092caccc16f.png";